export const getConfig = (type: string) => {
  const title = type === 'CLUE' ? '商机' : '销售'
  return {
    rowSelection: false,
    fieldControl: false,
    columns: [
      {
        title: 'ID',
        dataIndex: 'id',
        width: 200,
        render: 'IdRender'
      },
      {
        title: `${title}计划名称`,
        dataIndex: 'name',
        width: 200,
        ellipsis: true,
      },
      {
        title: '适用组织范围',
        dataIndex: 'storeNames',
        width: 160,
        render: (v) => v?.join(', '),
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: `${title}节点`,
        dataIndex: 'nodeDesc',
        width: 200,
        ellipsis: {
          showTitle: true,
        },
      },
      {title: '是否启用', dataIndex: 'enable', width: 160, render: 'switchRender'},
      {title: '优先级', dataIndex: 'weight', width: 160, render: 'dragRender'},
      {
        title: '创建时间',
        dataIndex: 'createdTime',
        itemType: 'dateTime',
        width: 160,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        title: '操作',
        dataIndex: 'actions',
        width: 140,
        render: 'actionRender',
        fixed: 'right',
      },
    ],
    search: [
      {
        label: '适用组织范围',
        name: 'storeIds',
        mode: 'multiple',
        itemType: 'select',
        data: 'companyList',
        labelKey: 'name',
        key: 'id',
        labelProps: {"width": 100}
      }
    ],
    footer: [
      {
        label: '新增',
        // auth: 'priceButton1',
        type: 'primary',
        events: ['onClick:onAdd'],
      },
    ],
  }
}
